import React from "react";
import { useRef } from "react";
import { useState } from "react";

const MyCvLoader = ({ name, setData }) => {
	const fileInput = useRef(null);

	const [file, setFile] = useState(null);
	// const [previewUrl, setPreviewUrl] = useState("");

	const handleOndragOver = (event) => {
		event.preventDefault();
	};
	const handleOndrop = (event) => {
		//prevent the browser from opening the image
		event.preventDefault();
		event.stopPropagation();

		//let's grab the image file
		let cvFile = event.dataTransfer.files[0];
		setFile(cvFile);
		// setPreviewUrl(URL.createObjectURL(cvFile));
		setData((prevData) => ({
			...prevData,
			[name]: cvFile,
		}));
	};

	const handleInputFile = (file) => {
		//you can carry out any file validations here...
		setFile(file);
		// setPreviewUrl(URL.createObjectURL(file));
		setData((prevData) => ({
			...prevData,
			[name]: file,
		}));
	};


	return (
		<>
			
				<div
					style={{
						backgroundColor: "#F3F6F9",
					}}
					className="drop_zone"
					onDragOver={handleOndragOver}
					onDrop={handleOndrop}
					onClick={() => fileInput.current.click()}
				>
					<p style={{ fontSize: 16 }}>
						Click or Drag and drop CV here....
					</p>
				</div>
			
			
			<input
				ref={fileInput}
				hidden={true}
				id="file"
				type="file"
				style={{ display: "none" }}
				name="selectedFile"
				className="form-control"
				autoComplete="off"
				onChange={(e) => handleInputFile(e.target.files[0])}
			/>
		</>
	);
};
export default MyCvLoader;
